import styled from 'styled-components';
import { fontSize } from '../../styles/mixins';
import Anchor from '../Anchor';

export const StyledAnchor = styled(Anchor)`
  display: flex;
  ${fontSize(12)};
  font-weight: bold;
  align-items: center;
`;
